export default __webpack_public_path__ + "static/media/thumbs-up.dcd2af24.svg";